const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
const quickAddRoot = window.Shopify?.routes?.root || '/';
// Prepare bundle details before the first cart interaction.
function preloadMirchiBundleDetails() {
  window.mirchiBundleDetailsPromise ??= fetch(
    `${quickAddRoot}products/sona-masoori-bundle.js`
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error('Could not load bundle details.');
      }
      return response.json();
    })
    .catch(() => {
      window.mirchiBundleDetailsPromise = null;
      return null;
    });
}

if (document.readyState === 'complete') {
  preloadMirchiBundleDetails();
} else {
  window.addEventListener(
    'load',
    preloadMirchiBundleDetails,
    { once: true }
  );
}
/* Sliding order-limit notification */
window.mirchiShowLimitMessage = function (message) {
  let toast = document.getElementById('mirchi-limit-toast');

  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'mirchi-limit-toast';
    toast.className = 'mirchi-limit-toast';
    toast.innerHTML = `
      <span class="mirchi-limit-toast__text"
            role="status"
            aria-live="polite"></span>
      <button type="button"
              class="mirchi-limit-toast__close"
              aria-label="Close notification">×</button>
    `;

    document.body.appendChild(toast);

    toast.querySelector('button').addEventListener('click', () => {
      clearTimeout(toast.hideTimer);
      toast.classList.remove('is-visible');
    });
  }

  clearTimeout(toast.hideTimer);

  toast.querySelector('.mirchi-limit-toast__text').textContent =
    message;

  requestAnimationFrame(() => {
    toast.classList.add('is-visible');
  });

  toast.hideTimer = setTimeout(() => {
    toast.classList.remove('is-visible');
  }, 5000);
};
/* Limit each item labelled 10 kg to two bags */
window.mirchiCheckBagLimit = async function (
  variantId,
  quantity,
  action = 'change',
  line = null,
  knownCart = null
) {
  try {
    if (action === 'change' && Number(quantity) === 0) {
      return true;
    }

    const cart = knownCart || await getCart();

    const target = line
      ? cart.items[Number(line) - 1]
      : cart.items.find(
          (item) => String(item.variant_id) === String(variantId)
        );
/* Limit this Shopify bundle to one per order */
const bundleHandle = 'sona-masoori-bundle';

window.mirchiBundleDetailsPromise ??= fetch(
  `${window.Shopify?.routes?.root || '/'}products/${bundleHandle}.js`
).then((response) => {
  if (!response.ok) {
    throw new Error('Could not load bundle details.');
  }

  return response.json();
}).catch((error) => {
  window.mirchiBundleDetailsPromise = null;
  throw error;
});

const bundle = await window.mirchiBundleDetailsPromise;

const isBundleRequest = target
  ? String(target.product_id) === String(bundle.id)
  : bundle.variants.some(
      (variant) => String(variant.id) === String(variantId)
    );

if (isBundleRequest) {
  const currentBundleQuantity = cart.items
    .filter(
      (item) => String(item.product_id) === String(bundle.id)
    )
    .reduce((total, item) => total + item.quantity, 0);

  const requestedBundleQuantity = action === 'add'
    ? currentBundleQuantity + Number(quantity)
    : currentBundleQuantity - (target?.quantity || 0)
      + Number(quantity);

  if (requestedBundleQuantity > 1) {
    window.mirchiShowLimitMessage(
      'Everyday Essential Bundle — limited to 1 bundle per order.'
    );
    return false;
  }

  return true;
}
    if (!target) return true;

    const title = [
      target.product_title,
      target.variant_title,
    ].filter(Boolean).join(' ');

    if (!/(?:^|[^0-9])10\s*kg\b/i.test(title)) return true;

    const matchingItems = cart.items.filter(
      (item) => String(item.variant_id) === String(target.variant_id)
    );

    const currentQuantity = matchingItems.reduce(
      (total, item) => total + item.quantity,
      0
    );

    const requestedQuantity = action === 'add'
      ? currentQuantity + Number(quantity)
      : currentQuantity - target.quantity + Number(quantity);

    if (requestedQuantity > 2) {
      window.mirchiShowLimitMessage(
        `${target.product_title} — Purchase Limit: To help everyone enjoy our range, this item is limited to 2 bags per order.`
      );
      return false;
    }

    return true;
  } catch (error) {
    console.error(error);
    window.alert('Could not check the quantity. Please try again.');
    return false;
  }
};

let mirchiCartReadPromise = null;

function getCart() {
  if (mirchiCartReadPromise) {
    return mirchiCartReadPromise;
  }

  mirchiCartReadPromise = fetch(`${quickAddRoot}cart.js`, {
    cache: 'no-store',
    headers: { Accept: 'application/json' }
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Could not load cart');
      }
      return response.json();
    })
    .finally(() => {
      mirchiCartReadPromise = null;
    });

  return mirchiCartReadPromise;
}

function getCartItem(cart, variantId) {
  return cart.items.find(
    (item) => String(item.variant_id) === String(variantId)
  );
}

function updateHeaderCartCount(cart) {
  const cartIcon = document.querySelector('#cart-icon-bubble');

  if (!cartIcon) return;

  let count = cartIcon.querySelector('.quick-header-cart-count');

  if (!count) {
    count = document.createElement('span');
    count.className = 'quick-header-cart-count';
    cartIcon.appendChild(count);
  }

  count.hidden = cart.item_count === 0;
  count.textContent = cart.item_count > 0 ? cart.item_count : '';
}

function updateQuickAddControl(quickAdd, quantity) {
  const form = quickAdd.querySelector(
    'form[data-type="add-to-cart-form"]'
  );

  if (!form) return;

  let stepper = quickAdd.querySelector('.quick-add-stepper');

 if (quantity > 0) {
  form.style.setProperty('display', 'none', 'important');

  if (!stepper) {
    stepper = document.createElement('div');
    stepper.className = 'quick-add-stepper';

    stepper.innerHTML = `
      <button type="button" class="quick-add-stepper__button" data-action="decrease" aria-label="Reduce quantity">−</button>
      <span class="quick-add-stepper__quantity">1</span>
      <button type="button" class="quick-add-stepper__button" data-action="increase" aria-label="Increase quantity">+</button>
    `;

    quickAdd.appendChild(stepper);
  }

  stepper.querySelector('.quick-add-stepper__quantity').textContent =
    quantity;
} else {
  form.style.removeProperty('display');

  if (stepper) {
    stepper.remove();
  }
}
}

async function refreshAllQuickAddControls(knownCart = null) {
  const cart = knownCart || await getCart();

  updateHeaderCartCount(cart);

  document
    .querySelectorAll('.card-price-row .quick-add')
    .forEach((quickAdd) => {
      const variantInput = quickAdd.querySelector(
        'input[name="id"]'
      );

      if (!variantInput) return;

      const item = getCartItem(cart, variantInput.value);

      updateQuickAddControl(
        quickAdd,
        item ? item.quantity : 0
      );
    });
}

document.addEventListener(
  'submit',
  async (event) => {
    const form = event.target;

    if (
      !form.matches(
        '.card-price-row form[data-type="add-to-cart-form"]'
      )
    ) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    const button = form.querySelector('[type="submit"]');
    const quickAdd = form.closest('.quick-add');

    if (button.disabled) return;

button.disabled = true;
button.classList.add('loading');
button.setAttribute('aria-busy', 'true');
quickAdd.querySelector('.loading__spinner')
  ?.classList.remove('hidden');

    try {
  const cartUI =
    document.querySelector('cart-notification') ||
    document.querySelector('cart-drawer');

  const formData = new FormData(form);
 const limitTitle = form.dataset.mirchiLimitTitle;
const productHandle = form.dataset.mirchiProductHandle;

const needsLimitCheck =
  limitTitle === undefined ||
  !productHandle ||
  productHandle === 'sona-masoori-bundle' ||
  /(?:^|[^0-9])10\s*kg\b/i.test(limitTitle);

const allowed = !needsLimitCheck ||
  await window.mirchiCheckBagLimit(
    formData.get('id'),
    Number(formData.get('quantity')) || 1,
    'add'
  );

if (!allowed) return;

  if (cartUI) {
    formData.set(
      'sections',
      cartUI.getSectionsToRender().map((section) => section.id).join(',')
    );
    formData.set('sections_url', window.location.pathname);
    cartUI.setActiveElement(button);
  }

  const response = await fetch(`${quickAddRoot}cart/add.js`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: formData,
  });

      if (!response.ok) {
        throw new Error('Could not add product');
      }

     const addedProduct = await response.json();
     // Use Shopify's confirmed line quantity immediately.
const confirmedQuantity = Number(addedProduct.quantity);

if (
  String(addedProduct.variant_id || addedProduct.id) ===
    String(formData.get('id')) &&
  Number.isInteger(confirmedQuantity) &&
  confirmedQuantity > 0
) {
  updateQuickAddControl(quickAdd, confirmedQuantity);

  // Keep quantity changes locked until cart synchronization finishes.
  quickAdd.querySelectorAll('.quick-add-stepper__button')
    .forEach((control) => {
      control.disabled = true;
    });
}

// Update the drawer using the successful add response.
if (cartUI) {
  cartUI.renderContents(addedProduct);
}

// Read the confirmed cart and update all matching cards.
const cart = await getCart();

await Promise.all([
  refreshAllQuickAddControls(cart),
  refreshMirchiProductControls(cart)
]);
    } catch (error) {
      console.error(error);
    } finally {
  button.disabled = false;
  button.classList.remove('loading');
  button.removeAttribute('aria-busy');

  quickAdd.querySelector('.loading__spinner')
    ?.classList.add('hidden');

  quickAdd.querySelectorAll('.quick-add-stepper__button')
    .forEach((control) => {
      control.disabled = false;
    });
}
  },
  true
);

document.addEventListener('click', async (event) => {
  const button = event.target.closest(
    '.quick-add-stepper__button'
  );

  if (!button) return;

  const quickAdd = button.closest('.quick-add');
  const variantInput = quickAdd.querySelector('input[name="id"]');

  if (!variantInput) return;

  button.disabled = true;

  try {
    const cart = await getCart();
    const item = getCartItem(cart, variantInput.value);

    if (!item) return;

    const newQuantity =
      button.dataset.action === 'increase'
        ? item.quantity + 1
        : Math.max(0, item.quantity - 1);
      
      if (!await window.mirchiCheckBagLimit(
  variantInput.value,
  newQuantity,
  'change',
  null,
  cart
)) return;

    const response = await fetch(`${quickAddRoot}cart/change.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: item.key,
        quantity: newQuantity,
      }),
    });

    if (!response.ok) {
      throw new Error('Could not update quantity');
    }

    const updatedCart = await response.json();
    const updatedItem = getCartItem(
      updatedCart,
      variantInput.value
    );

    updateQuickAddControl(
      quickAdd,
      updatedItem ? updatedItem.quantity : 0
    );

       updateHeaderCartCount(updatedCart);

  publish(PUB_SUB_EVENTS.cartUpdate, {
  source: 'mirchi-collection-stepper',
  productVariantId: variantInput.value,
  cartData: updatedCart
});
  } catch (error) {
    console.error(error);
  } finally {
    button.disabled = false;
  }
});

function initialiseQuickAdd() {
  refreshAllQuickAddControls().catch(console.error);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initialiseQuickAdd);
} else {
  initialiseQuickAdd();
}
/* Product-page Add to Cart / quantity controls */
let mirchiProductRefresh = 0;
let mirchiProductQuantityBusy = false;

async function refreshMirchiProductControls(knownCart = null) {
  const root = document.querySelector('product-info[id^="MainProduct-"]');
  if (!root) return;

 const refreshId = ++mirchiProductRefresh;
const cart = knownCart || await getCart();

  if (refreshId !== mirchiProductRefresh) return;

  root.querySelectorAll('product-form').forEach((productForm) => {
    const form = productForm.querySelector('form');
    const variant = form?.querySelector('[name="id"]');
    const addButton = form?.querySelector('[name="add"]');
    const stepper = form?.querySelector('.mirchi-product-stepper');

    if (!variant || !addButton || !stepper) return;

    const item = getCartItem(cart, variant.value);
    const quantity = item ? item.quantity : 0;

    addButton.hidden = quantity > 0;
    stepper.hidden = quantity === 0;

    stepper.querySelector('.mirchi-product-stepper__count')
      .textContent = quantity;

    stepper.querySelectorAll('button').forEach((button) => {
      button.disabled = mirchiProductQuantityBusy;
    });
  });
}

document.addEventListener('click', async (event) => {
  const button = event.target.closest(
    '.mirchi-product-stepper button[data-direction]'
  );

  if (!button || mirchiProductQuantityBusy) return;

  const productForm = button.closest('product-form');
  const form = productForm.querySelector('form');
  const variant = form.querySelector('[name="id"]');
  const root = productForm.closest('product-info');
  const stepper = button.closest('.mirchi-product-stepper');

  if (!variant || !root) return;

  mirchiProductQuantityBusy = true;
  stepper.querySelectorAll('button').forEach((control) => {
    control.disabled = true;
  });

  try {
    productForm.handleErrorMessage?.();

    const cart = await getCart();
    const item = getCartItem(cart, variant.value);

    if (!item) return;

    const originalQuantity = root.querySelector(
      '.product-form__quantity input[name="quantity"]'
    );

    const minimum = Number(originalQuantity?.dataset.min) || 1;
    const increment = Number(originalQuantity?.step) || 1;

    const quantity = button.dataset.direction === 'plus'
      ? item.quantity + increment
      : item.quantity <= minimum
        ? 0
        : Math.max(minimum, item.quantity - increment);
      if (!await window.mirchiCheckBagLimit(
  variant.value,
  quantity,
  'change',
  null,
  cart
)) return;

    const drawer = document.querySelector('cart-drawer');
    const body = {
      id: item.key,
      quantity: quantity,
      sections_url: window.location.pathname,
    };

    if (drawer) {
      body.sections = drawer.getSectionsToRender()
        .map((section) => section.id);
    }

    const response = await fetch(`${quickAddRoot}cart/change.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    const updatedCart = await response.json();

    if (!response.ok) {
      throw new Error(
        updatedCart.description || 'Could not update quantity'
      );
    }

    if (drawer && updatedCart.sections) {
      drawer.renderContents(updatedCart);
      drawer.classList.toggle(
        'is-empty',
        updatedCart.item_count === 0
      );
    }

    updateHeaderCartCount(updatedCart);

    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'mirchi-product-stepper',
      productVariantId: variant.value,
      cartData: updatedCart,
    });
  } catch (error) {
    console.error(error);
    productForm.handleErrorMessage?.(error.message);
  } finally {
    mirchiProductQuantityBusy = false;
    stepper.querySelectorAll('button').forEach((control) => {
      control.disabled = false;
    });
    refreshMirchiProductControls().catch(console.error);
  }
});

subscribe(PUB_SUB_EVENTS.variantChange, () => {
  refreshMirchiProductControls().catch(console.error);
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    refreshMirchiProductControls().catch(console.error);
  });
} else {
  refreshMirchiProductControls().catch(console.error);
}
subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
  try {
    const suppliedCart = event?.cartData;

    const isCompleteCart =
      Array.isArray(suppliedCart?.items) &&
      typeof suppliedCart.item_count === 'number';

    const cart = isCompleteCart
      ? suppliedCart
      : await getCart();

    await Promise.all([
      refreshAllQuickAddControls(cart),
      refreshMirchiProductControls(cart)
    ]);
  } catch (error) {
    console.error('Could not refresh cart controls:', error);
  }
});
// Refresh cart displays when Back restores a saved page.
window.addEventListener('pageshow', async (event) => {
  if (!event.persisted) return;

  try {
    const cartUI =
      document.querySelector('cart-notification') ||
      document.querySelector('cart-drawer');

    const sectionIds = cartUI
      ? cartUI.getSectionsToRender().map((section) => section.id)
      : [];

    const [cart, sections] = await Promise.all([
      getCart(),
      sectionIds.length
        ? fetch(
            `${quickAddRoot}?sections=${encodeURIComponent(
              sectionIds.join(',')
            )}`,
            { cache: 'no-store' }
          ).then((response) => {
            if (!response.ok) {
              throw new Error('Could not refresh cart sections');
            }
            return response.json();
          })
        : Promise.resolve(null)
    ]);

    if (cartUI && sections) {
      cartUI.renderContents({ sections });
      cartUI.classList.toggle('is-empty', cart.item_count === 0);
    }

    await Promise.all([
      refreshAllQuickAddControls(cart),
      refreshMirchiProductControls(cart)
    ]);
  } catch (error) {
    console.error('Could not refresh restored cart:', error);
  }
});